<div class="messageContainer">
  <div class="messageIcon">
    <mat-icon>{{getIcon}}</mat-icon>
  </div>
  <div class="messageText">
    <span>{{data.message}}</span>
  </div>
</div>
